import React from 'react';

const useGetLimit = () => {
	const limitItem = React.useMemo(() => {
		const limits = window.portal?.user?.limits();
		let tempLimit = limits?.[0];
		limits?.forEach((item) => {
			if (!tempLimit) tempLimit = item;
			if (item.limit < tempLimit?.limit) {
				tempLimit = item;
			}
		});
		return tempLimit;
	}, []);

	return {
		limitItem,
	};
};
export default useGetLimit;
